import React, { useEffect, useState } from 'react';
import { NoData } from '../_components/NoData';
import { Path } from '../_components/Path';
import { apiConstants } from '../_constants';
import { topicService } from '../_services/topic.service';
import './bookmark.css';

export const BookmarkList = () => {
  // const [isLoading, setIsLoading] = useState(false);
  // const [isBookmarkUpdating, setIsBookmarkUpdating] = useState(false);
  const [bookmarkData, setBookmarkData] = useState([]);
  const [expand, setExpand] = useState({});
  const [query] = useState({
    pageVo: {
      pageNo: 1,
      noOfItems: 8,
    },
  });

  useEffect(() => {
    getBookmarkList();
  }, []);

  const getBookmarkList = () => {
    // setIsLoading(true);
    topicService.getbookmarks(query).then(
      (bookmark) => {
        // setIsLoading(false);
        // setIsBookmarkUpdating(false);
        if (bookmark?.data?.length) {
          setBookmarkData(bookmark.data);
        } else {
          setBookmarkData([]);
        }
      },
      (err) => {
        console.log(err, 'bookmark===error');
        // setIsLoading(false);
        // setIsBookmarkUpdating(false);
      },
    );
  };

  // function to delete bookmark
  const deleteBookmarks = (data) => {
    // setIsBookmarkUpdating(true);
    topicService.bookmarkAdd({ _id: data, bookmark: false }).then(
      () => {
        getBookmarkList();
      },
      (err) => {
        console.error(err);
      },
    );
  };

  const toggleDropdown = (item_id) => {
    setExpand((prevState) => ({
      ...prevState,
      [item_id]: !prevState[item_id] || false,
    }));
  };

  const renderSubjects = (data) => {
    return data.map((subject, index) => {
      return (
        <div key={index} className='subjectitem'>
          <div className='bookmarksubjectname'>{subject?.subject_name}</div>
          {renderBookmark(subject?.topics)}
        </div>
      );
    });
  };

  const renderBookmark = (bookmars) => {
    return bookmars?.map((bookmark, index) => {
      return (
        <div key={index} className='d-flex topicbookmarkbox justify-content-between' dir='rtl'>
          <div className='topiccontainer'>
            <img
              src={
                bookmark?.image ? apiConstants.imgUrl + bookmark?.image : '/img/subjectdummy.jpeg'
              }
              className='topiclistimg'
            />
            <div>
              <div className='bookmarktopicname'>{bookmark?.topic_name}</div>
              <div className='descitem'>
                <img src='/img/question_icon.png' className='desc_icon' />{' '}
                {bookmark?.total_questions} Questions
              </div>
            </div>
          </div>
          <div
            className='bookmark'
            onClick={() => {
              deleteBookmarks(bookmark?.bookmark_id);
            }}
          >
            <img
              src={bookmark?.bookmark_id ? '/img/bookmark_filled.png' : '/img/bkmark.png'}
              className='bookmarkicon'
            />
          </div>
        </div>
      );
    });
  };
  return (
    <div className='container'>
      {/* {console.log(isLoading, isBookmarkUpdating, 'this is bookmarkdata')} */}
      <Path pathList={[{ name: 'Bookmarks' }]} />
      <div className='bookmarklistcontainer gap-2'>
        {bookmarkData.map((item, index) => (
          <div className='courseitem' key={index}>
            <div
              className='d-flex align-items-center gap-2'
              onClick={() => toggleDropdown(item?.course_id)}
            >
              <div className='bookmarkcoursehead'>{item?.course_name}</div>
              <img
                src={expand[item?.course_id] ? '/img/arrowdown.png' : '/img/arrowupcircle.png'}
                className='expandicon'
              />
            </div>
            {!expand[item?.course_id] && (
              <div className='subjects mt-2 mb-2'>{renderSubjects(item?.nested_data)}</div>
            )}
            <div className='line'></div>
          </div>
        ))}
      </div>
      {bookmarkData?.length == 0 && <NoData text='You Have No Bookmarks' />}
    </div>
  );
};
